import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT, LOGIN } from '../authentication/constants'

const initialState = fromJS({})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.PROJECT_CREATED:
      return state
        .set('projectCreated', true)
        .set('defaultProjectRole', action.role)
        .set('createProject', false)
        .set('newProjectId', action.newProjectId)
        .set('nameNotAvailable', false)
    case actionTypes.CREATE_PROJECT_ERROR:
      return state
        .set('createProjectError', action.error)
        .set('createProject', false)
        .set('nameNotAvailable', false)
    case actionTypes.CLEAR_CREATE_PROJECT:
      return state
        .set('createProjectError', null)
        .set('projectCreated', false)
        .set('createProject', false)
        .set('newProjectId', null)
        .set('nameNotAvailable', false)
    case actionTypes.CREATE_PROJECT:
    case actionTypes.COPY_PROJECT:
      return state.set('createProject', true)
    case actionTypes.NAME_NOT_AVAILABLE:
      return state.set('createProject', false).set('nameNotAvailable', true)
    case LOGIN:
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
